import React, { useState } from "react";
import Button from "components/Form/fields/Button";
import { useToasts } from "react-toast-notifications";

const DEFAULT_COPY = {
  value: "Submit",
  loading: "Loading..."
};

const DEFAULT_CLASSES = {};

const ActionButton = ({
  onClick,
  copy: copyProps,
  customClasses,
  disabled,
  tag,
  loading: initLoading
}) => {
  const { addToast } = useToasts();
  const classes = {
    ...DEFAULT_CLASSES,
    ...customClasses
  };
  const copy = { ...DEFAULT_COPY, ...copyProps };

  const [loading, setLoading] = useState(Boolean(initLoading || false));
  const buttonProps = {
    disabled: loading || disabled,
    tag,
    onClick: async () => {
      setLoading(true);
      try {
        await onClick();
      } catch (error) {
        addToast(error.message, {
          appearance: "error",
          autoDismiss: true
        });
      }
      setLoading(false);
    },
    loading,
    copy: loading ? copy.loading : copy.value,
    classes
  };

  return <Button {...buttonProps} />;
};

export default ActionButton;
